import { useContext, useMemo } from 'react';
import { ThemeContext } from '../context/ThemeContext';

export function useThemeClasses(modoOscuroProp) {
  const { modoOscuro: ctx } = useContext(ThemeContext);
  const modoOscuro = modoOscuroProp ?? ctx ?? false;

  return useMemo(() => {
    const box = modoOscuro ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200';
    const section = modoOscuro ? 'bg-gray-800/50 border-gray-700' : 'bg-gray-50 border-gray-200';
    const textPri = modoOscuro ? 'text-white' : 'text-gray-900';
    const textSec = modoOscuro ? 'text-gray-300' : 'text-gray-600';
    const textMuted = modoOscuro ? 'text-gray-400' : 'text-gray-500';
    const labelClass = modoOscuro ? 'text-gray-400' : 'text-gray-700';
    const inputClass = modoOscuro
      ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-400 focus:ring-[#1F80FF] focus:border-[#1F80FF]'
      : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-[#1F80FF] focus:border-[#1F80FF]';
    const tabInactive = modoOscuro ? 'text-gray-400 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100';
    const btnPrimary = 'bg-[#1F80FF] hover:bg-[#004AAD] text-white';
    const btnSecondary = modoOscuro ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-gray-100 text-gray-900 hover:bg-gray-200';
    const btnOutline = modoOscuro ? 'border-gray-600 text-white hover:bg-gray-700' : 'border-gray-300 text-gray-900 hover:bg-gray-50';
    const divide = modoOscuro ? 'border-gray-700' : 'border-gray-200';
    const alertSuccess = modoOscuro ? 'bg-green-900/30 border-green-600 text-green-200' : 'bg-green-50 border-green-400 text-green-800';
    const alertError = modoOscuro ? 'bg-red-900/30 border-red-600 text-red-200' : 'bg-red-50 border-red-400 text-red-800';
    const alertWarning = modoOscuro ? 'bg-amber-900/30 border-amber-600 text-amber-200' : 'bg-amber-50 border-amber-400 text-amber-800';
    const alertInfo = modoOscuro ? 'bg-blue-900/30 border-blue-600 text-blue-200' : 'bg-blue-50 border-blue-400 text-blue-800';
    const readonlyBox = modoOscuro ? 'bg-gray-800 border-gray-600 text-blue-300' : 'bg-gray-50 border-gray-300 text-[#1F80FF]';

    return {
      modoOscuro,
      box,
      section,
      textPri,
      textSec,
      textMuted,
      labelClass,
      inputClass,
      tabInactive,
      btnPrimary,
      btnSecondary,
      btnOutline,
      divide,
      alertSuccess,
      alertError,
      alertWarning,
      alertInfo,
      readonlyBox
    };
  }, [modoOscuro]);
}
